import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import './App.css';

// Component Imports
import HomePage from './pages/HomePage';
import AllPaintings from "./pages/AllPaintings";
import AddPainting from "./pages/AddPainting";
import PaintingDetails from "./pages/PaintingDetails";
import Exhibition from "./pages/Exhibition";
import Cart from "./pages/Cart";
import SignUpPage from "./pages/SignUpPage";
import Wishlist from "./pages/Wishlist";
import MyOffers from "./pages/MyOffers";
import ArtistOffer from "./pages/ArtistOffers";
import Navbar from "./components/Navbar";
import MobileNav from "./components/MobileNav";
import MyOrders from "./pages/MyOrders";
import Profile from "./pages/Profile";
import ArtistDashboard from "./pages/ArtistDashboard";
import SeriesDetails from "./pages/SeriesDetails";
import Projects from "./pages/Projects";
import AboutArtist from "./pages/AboutArtist";
import Contact from "./pages/Contact";
import CategoryDetails from './pages/CategoryDetails';
import AllPrints from './pages/AllPrints';
import PrintDetails from "./pages/PrintDetails";
import OriginalDetails from "./pages/OriginalDetails";
import WorldFrameSeries from "./pages/WorldFrameSeries";
import CustomBiography from "./pages/CustomBiography";
import PreviewExhibition from "./pages/PrivateViewing"; 
import PrivateViewing from "./pages/PrivateViewing";
import VIPDossier from "./pages/VIPDossier";
import { SEOProvider } from "./components/SEOManager";

const MainLayout = () => {
  return (
    <>
      <Navbar />
      {/* <MobileNav /> */}
      
      {/* Outlet renders whatever child route is currently active */}
      <Outlet /> 
      
      {/* You can add your <Footer /> here later, and it will automatically hide on the preview page too */}
    </>
  );
};

function App() {
  return (
    
    <Router>
              <SEOProvider>
      <Routes>
        {/* --- ROUTES WITH NAVBAR --- */}
        {/* All routes inside this wrapper will display the Navbar */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/allpaintings/:category" element={<AllPaintings />} />
          <Route path="/addpainting" element={<AddPainting />} />
          <Route path="/paintingDetails/:id" element={<PaintingDetails />} />
          <Route path="/exhibitions" element={<Exhibition />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/signUp" element={<SignUpPage />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/myOffers" element={<MyOffers />} />
          <Route path="/artistOffer" element={<ArtistOffer />} />
          <Route path="/myOrders" element={<MyOrders />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/artistDashboard" element={<ArtistDashboard />} />
          <Route path="/series/:seriesName" element={<SeriesDetails />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<AboutArtist />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/category/:categoryName" element={<CategoryDetails />} />
          <Route path="/allprints" element={<AllPrints />} />
          <Route path="/printDetails/:id" element={<PrintDetails />} />
          <Route path="/originalDetails/:id" element={<OriginalDetails />} />
          <Route path="/worldFrameSeries" element={<WorldFrameSeries />} />
          <Route path="/customBiography" element={<CustomBiography />} />
          <Route path="/VIPDossier/:id" element={<VIPDossier />} />
        </Route>

        {/* --- STANDALONE ROUTES (NO NAVBAR) --- */}
        {/* Because this is outside the MainLayout, it renders completely alone */}
        <Route path="/preview/exhibition" element={<PrivateViewing />} />
        
      </Routes>
            </SEOProvider>

    </Router>
  );
}

export default App;